import {Component} from '@lib/Component';
import {IComponentGenerator} from '@services/types';

type ComponentCreator = new () => Component;

export type ComponentMap = Record<string, ComponentCreator>;

/**
 * ComponentGenerator
 */
export class ComponentGenerator implements IComponentGenerator {
  private _components = new Map();

  constructor(private map: ComponentMap) {}

  public initialize() {
    Object.entries(this.map).map(([selectors, ComponentClass]) => {
      const elements = [
        ...(document.querySelectorAll(selectors) as NodeListOf<HTMLElement>),
      ];
      elements?.map((element) => {
        const c = new ComponentClass();
        c.mount(element);
        this._components.set(c.element, c);
      });
    });
  }

  public refresh() {
    Object.entries(this.map).map(([selectors, ComponentClass]) => {
      const elements = [
        ...(document.querySelectorAll(selectors) as NodeListOf<HTMLElement>),
      ];
      elements?.map((element) => {
        if (!(ComponentClass as typeof Component).isShared) {
          const c = new ComponentClass();
          c.mount(element);
          this._components.set(c.element, c);
        }
      });
    });
  }

  public willUnmount() {
    this._components.forEach((component) => {
      if (!component.isShared) {
        component.element && component.willUnmount();
      }
    });
  }

  public unmount() {
    this._components.forEach((component) => {
      if (!component.isShared) {
        this._components.delete(component.element);
        component.element && component.destroy();
      }
    });
  }
}
